import { useTheme } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";

type TypeLabelSize = "small" | "medium" | "large";

interface TypeLabelProps {
  label: string;
  labelColor: string;
  size?: TypeLabelSize;
}

const getFontSize = (size: TypeLabelSize = "small"): string => {
  switch (size) {
    case "small":
      return "0.875rem";
    case "medium":
      return "1rem";
    case "large":
      return "1.5rem";
    default:
      return "0.875rem";
  }
};

export const TypeLabel = ({ label, labelColor, size = "small" }: TypeLabelProps) => {
  if (!label) return null;

  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: labelColor,
        color: theme.palette.common.black,
        padding: "4px 8px",
        borderRadius: 1,
        display: "inline-block",
        fontSize: getFontSize(size),
      }}
    >
      {label}
    </Box>
  );
};

export default TypeLabel;
